import { render, staticRenderFns } from "./PostChallengeDialog.vue?vue&type=template&id=a35b0c9a&scoped=true"
import script from "./PostChallengeDialog.vue?vue&type=script&lang=ts"
export * from "./PostChallengeDialog.vue?vue&type=script&lang=ts"
import style0 from "./PostChallengeDialog.vue?vue&type=style&index=0&id=a35b0c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b0c9a",
  null
  
)

export default component.exports